import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { toast } from "react-toastify";
import Error from "../../../Modules/StyledComponents/Toastify/Error";

import {
  changeAppointmentData,
  clearAppointmentData,
} from "../../../StateManagement/Reducers/AppointmentsState";

import {
  Table,
  Text,
  NormalImage,
  Button,
  SpanCont,
} from "../../StyledComponents";
import {
  Tablewhole,
  PastTopTitle,
  TableHead,
  TableBody,
  TableHeadCell,
  TableBodyCell,
  TableRow,
  ResText,
  RespTitle,
  StatusBadge,
} from "./styles";

import { InitialsText } from "../AddAppointment/Styles";
import { HiOutlineVideoCamera } from "react-icons/hi";

import Empt_img from "../../../Assets/images/Empty_Data.png";

const PastAppointment = ({ onScheduleClick }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [changeToText, SetChangeToText] = useState(false);

  let backurl = "";
  let firstDot = window.location.hostname.split(".");
  let DBhost;
  if (firstDot[0] !== "localhost") {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS.replace(
      "oemr",
      firstDot[0],
    );
  } else {
    backurl = process.env.REACT_APP_BACKEND_FILE_ACCESS;
  }
  if (
    firstDot[0] === "localhost" ||
    firstDot[0] === "test" ||
    firstDot[0] === "mumbai" ||
    firstDot[0] === "production" ||
    firstDot[0] === "ehr" ||
    firstDot[0] === "ehr1" ||
    firstDot[0] === "dev"
  ) {
    DBhost = "default";
  } else {
    DBhost = firstDot[0];
  }

  const File_URL = backurl + "/sites/" + DBhost + "/documentimg/";

  const pastApptDetails = useSelector((state) => state.Appointments.PastAppt);
  const OnsiteAppReq = useSelector((state) => state.Appointments.OnsiteAppReq);

  const imageError = () => {
    SetChangeToText(!changeToText);
  };

  // const scheduleapp = () => {
  //   if (parseInt(OnsiteAppReq["allow_portal"]) === 1) {
  //     if (parseInt(OnsiteAppReq["individual_patient"]) === 0) {
  //       navigate("/appointment/add_appointment");
  //       dispatch(clearAppointmentData(""));
  //     } else if (
  //       parseInt(OnsiteAppReq["individual_patient"]) === 1 &&
  //       parseInt(OnsiteAppReq["newpat_allow"]) === 1
  //     ) {
  //       navigate("/appointment/add_appointment");
  //       dispatch(clearAppointmentData(""));
  //     } else {
  //       toast(<Error msg="You're not allow to Make an Appointment" />, {
  //         containerId: "B",
  //         className: "error_badge",
  //       });
  //     }
  //   } else {
  //     toast(<Error msg="You're not allow to Make an Appointment......" />, {
  //       containerId: "B",
  //       className: "error_badge",
  //     });
  //   }
  // };

  const scheduleapp = () => {
    if (parseInt(OnsiteAppReq["allow_portal"]) === 1) {
      if (parseInt(OnsiteAppReq["individual_patient"]) === 0) {
        dispatch(clearAppointmentData(""));
        if (onScheduleClick) onScheduleClick();
      } else if (
        parseInt(OnsiteAppReq["individual_patient"]) === 1 &&
        parseInt(OnsiteAppReq["newpat_allow"]) === 1
      ) {
        dispatch(clearAppointmentData(""));
        if (onScheduleClick) onScheduleClick();
      } else {
        toast(<Error msg="You're not allow to Make an Appointment" />, {
          containerId: "B",
          className: "error_badge",
        });
      }
    } else {
      toast(<Error msg="You're not allow to Make an Appointment......" />, {
        containerId: "B",
        className: "error_badge",
      });
    }
  };

  useEffect(() => {
    dispatch(changeAppointmentData({ name: "changeUrl", value: "" }));
  }, []);

  return (
    <>
      <Tablewhole>
        <PastTopTitle display="flex" justifyCont="space-between">
          <RespTitle fontSize="20px" fontWeight="600" alignItem="left">
            Appointment List
          </RespTitle>

          {/* <Text
              color="#FFFFFF"
              fontWeight="400"
              fontSize="1.5rem"
              marginRight="5px"
              padding="10px 12px"
              width="0%"
            >
              +
            </Text> */}
          <button
            onClick={scheduleapp}
            style={{
              background: "#407BFF",
              color: "#FFFFFF",
              border: "none",
              padding: "9px 10px",
              borderRadius: "6px",
              fontWeight: "500",
              fontSize: "13px",
              cursor: "pointer",
            }}
            onMouseOver={(e) => (e.target.style.background = "#2C6EF2")}
            onMouseOut={(e) => (e.target.style.background = "#407BFF")}
          >
            Schedule Appointment
          </button>
        </PastTopTitle>
        <div
          style={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
          }}
        >
          <Table
            style={{ display: "flex", flexDirection: "column", height: "100%" }}
          >
            <TableHead
              display="flex"
              width="100%"
              justifyCont="space-between"
              tableLayout="fixed"
              background="#F1F5F8"
              color="#407BFF"
              paddingRight="20px"
            >
              <TableRow
                display="grid"
                tempColumns="20% 14% 12% 14% 16% 14% 8%"
                tableLayout="fixed"
              >
                <TableHeadCell padding="16px 0 16px 20px" textAlign="left">
                  Provider
                </TableHeadCell>
                <TableHeadCell textAlign="left" padding="16px 0 16px 20px">
                  Date
                </TableHeadCell>
                <TableHeadCell
                  textAlign="left"
                  padding="16px 0 16px 20px"
                  paddingLeft="0px"
                >
                  Time
                </TableHeadCell>
                <TableHeadCell textAlign="left" padding="16px 0 16px 20px">
                  Facility
                </TableHeadCell>
                <TableHeadCell textAlign="left" padding="16px 0 16px 20px">
                  Appointment Type
                </TableHeadCell>
                <TableHeadCell textAlign="left" padding="16px 0 16px 20px">
                  Status
                </TableHeadCell>
                <TableHeadCell textAlign="left" padding="16px 0 16px 20px">
                  Action
                </TableHeadCell>
              </TableRow>
            </TableHead>
            <TableBody
              display="block"
              // height="calc(100% - 48px)"
              overflowX="hidden"
              width="100%"
              paddingRight="4px"
            >
              {pastApptDetails.length !== 0 ? (
                <>
                  {console.log("Past Appt Data:", pastApptDetails[0])}
                  {pastApptDetails.map((details) => (
                    <TableRow
                      tableLayout="fixed"
                      className="hover_row"
                      display="grid"
                      tempColumns="20% 14% 12% 16% 16% 14% 8%"
                      // justifyCont="space-between"
                      // margin="16px 0 0 10px"
                    >
                      <TableBodyCell padding="16px 0 16px 20px">
                        <SpanCont display="flex" flexDirection="row">
                          {details.img_url &&
                          details.img_url !== null &&
                          !changeToText ? (
                            <NormalImage
                              loading="lazy"
                              height="28px"
                              width="28px"
                              borderRadius="50%"
                              marginRight="8px"
                              src={File_URL + details.img_url}
                              onError={imageError}
                            />
                          ) : (
                            <InitialsText
                              margin="4px 6px 0 0"
                              padding="3px 6px"
                              height="28px"
                              width="28px"
                              fontSize="12px"
                            >
                              {details.initials}
                            </InitialsText>
                          )}
                          <ResText
                            wordBreak="break-word"
                            mt="0px"
                            mb="0px"
                            fontWeight="600"
                            fontSize="12px"
                            width="110px"
                            align="left"
                            display="inline"
                            alignItems="center"
                            style={{
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              whiteSpace: "nowrap",
                              marginTop: "10px",
                            }}
                            title={details.UserName}
                          >
                            {details.UserName}
                          </ResText>
                        </SpanCont>
                      </TableBodyCell>
                      <TableBodyCell
                        padding="16px 0px"
                        // width="120px"
                        display="flex"
                        alignItems="center"
                      >
                        {details.pc_recurrtype === "0"
                          ? moment(details.Date, "YYYY-MM-DD").format(
                              "ddd, DD MMM YYYY",
                            )
                          : moment(details.ApptFromDate, "YYYY-MM-DD").format(
                              "ddd, DD MMM YYYY",
                            )}
                        {details.pc_recurrtype !== "0" && " (Recurring)"}
                      </TableBodyCell>
                      <TableBodyCell
                        padding="16px 0px"
                        // width="140px"
                        display="flex"
                        alignItems="center"
                      >
                        {details.Time}
                      </TableBodyCell>
                      <TableBodyCell
                        padding="16px 0 16px 20px"
                        // width="120px"
                        display="inline"
                        alignItems="center"
                        wordBreak="break-word"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                          marginTop: "10px",
                        }}
                        title={details.facility_name}
                      >
                        {details.facility_name}
                      </TableBodyCell>

                      <TableBodyCell
                        padding="16px 0px"
                        display="flex"
                        alignItems="center"
                      >
                        {details.tele_health === "1"
                          ? "Telehealth"
                          : "Appointment"}
                      </TableBodyCell>
                      <TableBodyCell
                        padding="16px 0px"
                        display="flex"
                        alignItems="center"
                      >
                        {(() => {
                          if (details.pc_apptstatus === "COMPLETED") {
                            return (
                              <StatusBadge
                                bg="rgba(34,197,94,0.12)"
                                color="#22C55E"
                              >
                                Completed
                              </StatusBadge>
                            );
                          } else if (details.pc_apptstatus === "CANCELLED") {
                            return (
                              <StatusBadge
                                bg="rgba(239,68,68,0.12)"
                                color="#EF4444"
                              >
                                Cancelled
                              </StatusBadge>
                            );
                          } else if (details.pc_apptstatus === "NOSHOW") {
                            return (
                              <StatusBadge
                                bg="rgba(248,113,113,0.12)"
                                color="#F87171"
                              >
                                No Show
                              </StatusBadge>
                            );
                          }
                          return null;
                        })()}
                      </TableBodyCell>
                      <TableBodyCell
                        padding="16px 0px"
                        display="flex"
                        alignItems="center"
                      >
                        {details.pc_apptstatus === "NOSHOW" &&
                          String(details.tele_health) === "1" &&
                          details.start_url && (
                            <HiOutlineVideoCamera
                              size={20}
                              style={{ cursor: "pointer", color: "#119921" }}
                              onClick={() =>
                                window.open(details.start_url, "_blank")
                              }
                            />
                          )}
                      </TableBodyCell>
                    </TableRow>
                  ))}
                </>
              ) : (
                <>
                  <TableRow
                    display="flex"
                    alignItem="center"
                    justifyCont="center"
                  >
                    <TableBodyCell colSpan={5}>
                      <NormalImage
                        loading="lazy"
                        src={Empt_img}
                        height="230px"
                        width="308px"
                      />
                    </TableBodyCell>
                  </TableRow>
                </>
              )}
            </TableBody>
          </Table>
        </div>
      </Tablewhole>
    </>
  );
};

export default PastAppointment;
